module.exports = __webpack_public_path__ + "images/emoji/open_file_folder.3bef99712d74cbe27047.png";